import { routes } from 'constants/config';
import request from '../utils/request_ajax';

export default function trackEvent(
  eventType,
  eventData,
  trackBrowserInfo = true,
) {
  request.post(routes.EVENTS, {
    event_data: eventData,
    event_type: eventType,
    browser_information: trackBrowserInfo,
  });
}
